// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"6026b68a","168":"d5aba668","702":"b83d9778","914":"bac09cf0","977":"6499c9ca"}[chunkId] + ".chunk.js";
};